import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import BillOfSale from './pages/BillOfSale';
import Invoice from './pages/Invoice';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Subscription from './pages/Subscription';
import Profile from './pages/Profile';
import SignDocument from './pages/SignDocument';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import LandingPage from './pages/LandingPage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Guides from './pages/Guides';
import GuidesSuccess from './pages/GuidesSuccess';
import GuidesDownload from './pages/GuidesDownload';
import NotFound from './pages/NotFound';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminPromoters from './pages/admin/AdminPromoters';
import AdminBlog from './pages/admin/AdminBlog';
import AdminBlogEdit from './pages/admin/AdminBlogEdit';
import AdminLogs from './pages/admin/AdminLogs';

import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/bill-of-sale" element={<BillOfSale />} />
          <Route path="/bill-of-sale/:type" element={<LandingPage />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/sign/:token" element={<SignDocument />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/subscription/success" element={<SubscriptionSuccess />} />
          <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/success" element={<GuidesSuccess />} />
          <Route path="/guides/download/:token" element={<GuidesDownload />} />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/documents" 
            element={
              <ProtectedRoute>
                <Documents />
              </ProtectedRoute>
            } 
          />
          
          {/* Admin Routes */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/users" 
            element={
              <AdminRoute>
                <AdminUsers />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/users/:id" 
            element={
              <AdminRoute>
                <AdminUserDetail />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/promoters" 
            element={
              <AdminRoute>
                <AdminPromoters />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/blog" 
            element={
              <AdminRoute>
                <AdminBlog />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/blog/:id" 
            element={
              <AdminRoute>
                <AdminBlogEdit />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/logs" 
            element={
              <AdminRoute>
                <AdminLogs />
              </AdminRoute>
            } 
          />
          
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
